export enum DesktopClientViewport {
  Minimal = 'desktopMinimal',
  Regular = 'desktopRegular',
  Large = 'desktopLarge'
}

const desktopClientViewports: {
  [key in DesktopClientViewport]: { name: string; styles: { width: string; height: string } };
} = {
  [DesktopClientViewport.Minimal]: {
    name: 'Desktop Min Size',
    styles: {
      width: '920px',
      height: '395px'
    }
  },
  [DesktopClientViewport.Regular]: {
    name: 'Desktop Regular Size',
    styles: {
      width: '1256x',
      height: '798px'
    }
  },
  [DesktopClientViewport.Large]: {
    name: 'Desktop Large Size',
    styles: {
      width: '1656px',
      height: '894px'
    }
  }
};
export default desktopClientViewports;
